"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPaymentMethods = void 0;
var _staticApiClientReact = require("@ori/static-api-client-react");
var _getChildrenWithNavigationType = require("./getChildrenWithNavigationType");
const getPaymentMethods = footer => {
  const paymentMethods = (0, _getChildrenWithNavigationType.getChildrenWithNavigationType)(_staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.PaymentMethods, footer);
  const paymentMethodsItems = paymentMethods?.children.filter(item => item.linkType === _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.PaymentMethod);
  return paymentMethodsItems;
};
exports.getPaymentMethods = getPaymentMethods;
